import { createMuiTheme } from '@material-ui/core';

const theme = createMuiTheme({
  palette: {
    primary: {
      '50': '#CDE1D8',
      '100': '#A5D5C1',
      '200': '#79C8A7',
      '300': '#4EBA8F',
      '400': '#31B07E',
      '500': '#1DA772',
      '600': '#189764',
      '700': '#128153',
      '800': '#0C6C43',
      '900': '#024827',
      A100: '#88E6B6',
      A200: '#42E491',
      A400: '#2BD08E',
      A700: '#2BD08E',
    },
    secondary: {
      main: '#5fa9ff',
      light: '#97daff',
      dark: '#107abc',
    },
    error: {
      main: '#fe7877',
    },
    action: {
      selected: '#E8F1EC',
    },
  },
  typography: {
    fontFamily: ['Hiragino Sans', 'Roboto', 'Helvetica', 'Arial', 'sans-serif'].join(','),
    allVariants: {
      color: 'rgba(0, 0, 0, 0.87)',
    },
    h5: {
      fontWeight: 600,
    },
  },
  overrides: {
    MuiButton: {
      contained: {
        boxShadow: 'none',
        padding: '8px 20px',
      },
      // sizeSmall: {
      //   padding: '4px 16px',
      // },
    },
    MuiPaper: {
      elevation1: {
        boxShadow: 'none',
        border: `1px solid #CBD5E0`,
      },
      elevation2: {
        boxShadow: 'none',
        border: `1px solid #CBD5E0`,
      },
    },
  },
  props: {
    MuiTypography: {
      variant: 'body2',
    },
  },
});

export default theme;
